import React, { useMemo } from "react";
import { PieChart } from "../../ui/Graph";
import PropTypes from "prop-types";
const PieChartSmsDashboard = ({ data, loading }) => {
  const createArr = useMemo(() => {
    const arr = [];
    arr.push(Number(data?.i_api));
    arr.push(Number(data?.i_campaigns));
    return arr;
  }, [data]);

  return (
    <div className="min-h-[450px]">
      <PieChart
        title="Distribución de SMS por tipo de envío"
        labels={["API", "Campañas"]}
        dataSets={createArr}
        label="No. de SMS"
        loading={loading}
      />
    </div>
  );
};

PieChartSmsDashboard.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
};

export default PieChartSmsDashboard;
